<template>
    <svg class="size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6.82862" cy="6.82862" r="6.4834" transform="matrix(1 0 0.0281634 0.999603 2 7.88211)" stroke="currentColor" stroke-width="0.690438"/>
        <circle cx="6.82862" cy="6.82862" r="6.4834" transform="matrix(1 0 0.0281634 0.999603 7.02148 3)" stroke="currentColor" stroke-width="0.690438"/>
    </svg>
</template>
